export default __webpack_public_path__ + "static/media/me.bfdcef2e.png";